module.exports = __webpack_public_path__ + "static/media/pwa_install.0d71c967.png";